import jQuery from 'jquery';

let keys = {};
let scrollSetup = {}; // true or false per-key
let scrollTimeout;

let initKeys = function (key) {
  if (!keys[key]) {
    keys[key] = { callbacks: [], elementsData: [], lastDataSent: undefined };
  }
};

let on = function (key, fn) {
  initKeys(key);
  keys[key].callbacks.push(fn);

  return function () {
    let idx = keys[key].callbacks.indexOf(fn);
    delete keys[key].callbacks[idx];
  };
};

const percentWithinViewport = function (element, parentElement) {
  // Element top (wrt the window)
  const elementTop = element.offset().top;
  const parent = jQuery(parentElement);

  const scrollTop = parent.is(jQuery(window)) ? parent.scrollTop() : parent.offset().top;

  // space from top of bounding rect (parent) to the top of the element;
  // positive if the top of the element is visibily below (higher y value)
  // than the parent; negative if above.
  const spaceTop = elementTop - scrollTop;
  const elementHeight = element.height();
  const parentHeight = jQuery(parentElement).height();
  const scrollBottom = scrollTop + parentHeight;
  const elementBottom = elementTop + elementHeight;
  // Space from the bottom of the bounding rect (parent) to the bottom of the element;
  // positive if the bottom of the element is visibly lower than the parent's bottom;
  // negative if the element is higher than the parent (within/above the viewport bottom).
  const spaceBottom = elementBottom - scrollBottom;

  let heightInScreen = elementHeight - spaceBottom;

  if (spaceTop < 0) {
    heightInScreen -= spaceTop * -1;
  }

  if (spaceBottom < 0) {
    heightInScreen -= spaceBottom * -1;
  }

  let percentage = (heightInScreen / parentHeight) * 100;
  percentage = percentage < 0 ? 0 : percentage;

  return percentage;
};

const highestPercentageDataWithinViewportForElements = function (elDatas, parentEl) {
  let highestPercentage = 0;
  let highestElData = {};

  elDatas.forEach((elData) => {
    let el = elData.el;
    let elPercentage = percentWithinViewport(el, parentEl);

    if (elPercentage > highestPercentage) {
      highestPercentage = elPercentage;
      highestElData = elData;
    }
  });

  return highestElData.data;
};

let setupScroll = function (key, parentEl, forceReinit) {
  if (!scrollSetup[key] || forceReinit) {
    if (!parentEl) {
      parentEl = window;
    }

    jQuery(parentEl).on('scroll', () => {
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        for (let key in keys) {
          let keyData = keys[key];

          if (keyData.callbacks) {
            let data = highestPercentageDataWithinViewportForElements(keyData.elementsData, parentEl);

            if (keyData.lastDataSent != data) {
              keyData.callbacks.forEach((cb) => cb(data));
              keyData.lastDataSent = data;
            }
          }
        }
      }, 50);
    });

    scrollSetup[key] = true;
  }
};

let setup = function (key, parentSelector = undefined, forceReinit = false) {
  if (!parentSelector) {
    parentSelector = window;
  }

  setupScroll(key, parentSelector, forceReinit);
  initKeys(key);
};

let addElementForKey = function (el, key, data, id) {
  initKeys(key);

  id = id || JSON.stringify(data);
  const elementData = { el: jQuery(el), data: data, id: id };

  const { elementsData } = keys[key];
  const foundIndex = elementsData.findIndex((item) => {
    const { id: itemId } = item;
    return itemId === id;
  });

  if (foundIndex >= 0) {
    elementsData.splice(foundIndex, 1, elementData);
  } else {
    elementsData.push(elementData);
  }

  keys[key].elementsData = elementsData;
};

export default {
  setup,
  addElementForKey,
  on,
};
